import { Box, Button, Typography } from '@mui/material'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/constants'

/**
 * Shown in place of a page the signed-in user has no permission for. Rendered inside the
 * portal layout rather than redirecting, so a deliberately typed URL reads as "not for you"
 * instead of looking broken.
 */
export const Forbidden = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 160px)',
        gap: 1.5,
        textAlign: 'center',
        px: 2,
      }}
    >
      <LockOutlinedIcon sx={{ fontSize: 64, color: 'primary.main' }} />
      <Typography variant="h5" fontWeight={700}>
        You don&apos;t have access to this page
      </Typography>
      <Typography variant="bodyRegular2" color="text.secondary" sx={{ maxWidth: 420 }}>
        This page needs a permission your role doesn&apos;t include. If you think you should have
        it, ask your administrator.
      </Typography>
      <Button variant="contained" sx={{ mt: 1 }} onClick={() => navigate(ROUTES.APP.ROOT)}>
        Back to Home
      </Button>
    </Box>
  )
}
